import * as React from 'react';

import { scrollingContext } from '../context';
import { IScrollingBlock } from '../types';

export const useCurrentScrollingBlock = (): IScrollingBlock | null | undefined => {
  const { active, refBlocksState } = React.useContext(scrollingContext);

  return active ? refBlocksState[active] : null;
};
